$(document).ready(function () {

    // check slider-left-nav exists on the page
    var slider = $('.slider-left-nav');
    if(slider.length){
        // forEach function from Todd Motto's  blog
        var forEach = function (array, callback, scope) {
            for (var i = 0; i < array.length; i++) {
                callback.call(scope, i, array[i]); // passes back stuff we need
            }
        };

        forEach(slider, function (index, value) {
            // now fetch YOUR-SLUG from html (use value.getAttribute('data-name') for < IE10 support)
            var sliderDataName = value.getAttribute('data-name');
            var sliderId = '#' + sliderDataName;

            var tnsOptions = {
                container: sliderId,
                navContainer: '.nav-' + sliderDataName,
                autoplay: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                autoplayHoverPause: true,
                arrowKeys: true,
                items: 1,
                slideBy: "page",
                mouseDrag: true,
                swipeAngle: false,
                speed: 400,
                controlsText: ['<img src="images/left-chevron.svg">', '<img src="images/chevron-right.svg">'],
                mode: 'carousel',
                gutter: '50px',
                controls: true,
                lazyload: false,
                //axis: 'vertical'
            };

            if($(sliderId).length > 0 && tns !== undefined) {

                var carousel = undefined,
                    thumbsOpts = {};
                var wait = null;

                function iniThumbs(){
                    if(wait !== null) clearTimeout(wait);
                    wait = setTimeout(function(){
                        if(typeof carousel === 'object') carousel.destroy();
                        if ( window.matchMedia( '( min-width: 991px )' ).matches ) {
                            // Set options for screen wider than 768px width
                            thumbsOpts = {
                                axis: 'vertical'
                            }
                        }
                        else {
                            // Set options for screen smaller than 768px width
                            thumbsOpts = {
                                axis: 'horizontal'
                            };
                        }
                        carousel = tns(Object.assign({},tnsOptions,thumbsOpts));
                    },250);
                }
                // Reset on orientation change for mobile
                window.addEventListener('orientationchange',iniThumbs);
                // Reset on resize
                window.addEventListener('resize',iniThumbs);
                // Initialize at load
                iniThumbs();
            }
        });
        // make cursor grabbing on drag of slider
        var sliderImage = $('.tns-outer');
        sliderImage.on("mousedown touchstart", function() {
            $(this).css('cursor' , "grabbing")
        });

        sliderImage.on("mouseup touchend", function() {
            $(this).css('cursor' , "grab")
        })
    }
});



